export enum LimitStatusError {
  dayLimitExceeded = 'TRANSACTION_EXCEEDED_LIMIT_DAY',
  weekLimitExceeded = 'TRANSACTION_EXCEEDED_LIMIT_WEEK',
  monthLimitExceeded = 'TRANSACTION_EXCEEDED_LIMIT_MONTH',
}
